module.exports = __webpack_public_path__ + "files/861d7b72eb0ce4d0cf0988678da83afe.png";